export interface StyleClassExpression {
  styleClassExpression?: ItemExpression;
}

export type ItemExpression = (unknown) => string | null;
